export default __webpack_public_path__ + "images/BL.581ad79.png";